import { Link } from "@inertiajs/react";
import App from "../layouts/app";
import { Pen } from 'lucide-react';
import PageTitle from "../components/PageTitle";
import ContentWrapper from "../components/ContentWrapper";
import clsx from "clsx";

export enum Status {
    Draft = "Draft",
    Published = "Published",
    Archived = "Archived",
}

export interface Page {
    id: number;
    title: string;
    slug: string;
    short_description: string;
    content: string;
    status: Status;
}

export default function Pages({ pages: { data: pages } }: { pages: { data: Page[] } }) {

    const thClasses = "font-medium px-4 py-2 text-gray-500";
    const tdClasses = "border-t border-gray-200 px-4 py-2";

    return (
        <App>
            <PageTitle title="Pages" />
            <ContentWrapper>
                <div className="flex justify-between items-center">
                    <h2 className="text-lg">Pages</h2>
                    <Link href={`/admin/pages/add`} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md">Add Page</Link>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th className={clsx([thClasses, 'text-left'])}>Title</th>
                            <th className={clsx([thClasses, 'text-left'])}>Slug</th>
                            <th className={clsx([thClasses, 'text-right'])}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {pages.map((page) => (
                            <tr key={page.id}>
                                <td className={tdClasses}>{page.title}</td>
                                <td className={tdClasses}>{page.slug}</td>
                                <td className={tdClasses}>
                                    <div className="flex justify-end">

                                        <Link href={`/admin/pages/${page.id}`} className="text-indigo-600 hover:text-indigo-800">
                                            Edit
                                        </Link>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </ContentWrapper>
        </App >
    )
}